

































import { Vue, Component, Watch } from 'vue-property-decorator'
import { Button, Header, CustomLink, Subheader, Container, Logo, Divider, NegativeSubheader } from '../atoms/'
import { SocialLoginBox, EmailInputGroup } from '../molecules'
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import { REGISTER_MODULE, EMAIL_SERVER_ERROR, RESET_EMAIL_ERROR } from '../../store/modules/register/constant'
import { AUTH_MODULE, REQUEST_SOCIAL_LOGIN, REQUEST_EMAIL_LOGIN } from '../../store/modules/auth/constant'
import { SocialLoginPayload } from '../../store/api/type'
import { APP_MODULE, TRANSLATE, DISABLED_SOCIAL } from '../../store/modules/app/constant'
import translate from '@/language'

@Component({
  components: {
    Button,
    Container,
    Header,
    CustomLink,
    Subheader,
    SocialLoginBox,
    EmailInputGroup,
    Logo,
    Divider,
    NegativeSubheader
  },
  computed: {
    ...mapGetters(REGISTER_MODULE, [EMAIL_SERVER_ERROR]),
    ...mapGetters(APP_MODULE, [TRANSLATE, DISABLED_SOCIAL])
  },
  methods: {
    ...mapActions(REGISTER_MODULE, [RESET_EMAIL_ERROR]),
    ...mapActions(AUTH_MODULE, [REQUEST_SOCIAL_LOGIN, REQUEST_EMAIL_LOGIN])
  },
  validations: {
    email: {
      required
    }
  }
})
export default class Login extends Vue {
  private email?: string = ''
  error = ''

  @Watch('email')
  onEmailChange() {
    (this as any)[RESET_EMAIL_ERROR]()
    this.$v.email.$touch()
  }

  created() {
    const prefillEmail = this.$route.query.email
    if (prefillEmail) {
      this.email = prefillEmail.toString().trim()
    }
  }

  mounted() {
    (this as any)[RESET_EMAIL_ERROR]()
    this.$nextTick(() => {
      this.$v.$reset()
    })
    this.error = this.$route?.query?.error as string
  }

  get emailError(): string {
    const { email } = this.$v
    if ((this as any)[EMAIL_SERVER_ERROR]) {
      return (this as any)[EMAIL_SERVER_ERROR]
    }
    if (email.$error) {
      if (!email.required) {
        return translate('', 'error-email-required')
      } else if (!email.email) {
        return translate('', 'error-email-invalid')
      }
    }
    return ''
  }
  get isEmailError(): boolean {
    return this.emailError !== ''
  }
  get formError(): boolean {
    return this.$v.$invalid || this.isEmailError
  }
  goToRegister(): void {
    this.$router.push({ path: '/register', query: { email: this.email, ...this.$route?.query } })
  }
  async socialLogin(socialType: string) {
    const challenge = this.$route?.query?.challenge
    const payload: SocialLoginPayload = {
      provider: socialType,
      challenge: challenge as string,
      email: '',
      // eslint-disable-next-line @typescript-eslint/camelcase
      redirect_url: '',
      action: '',
      // eslint-disable-next-line @typescript-eslint/camelcase
      access_token: ''
    }
    return (this as any)[REQUEST_SOCIAL_LOGIN](payload)
  }
  async emailLogin() {
    this.$v.email.$touch()
    const challenge = this.$route?.query?.challenge
    if (!this.formError) {
      return (this as any)[REQUEST_EMAIL_LOGIN]({ email: this.email, challenge })
    }
  }
}
